import { Checkbox } from 'antd';
import PropTypes from 'prop-types';
import { useState } from 'react';

export const BaseCheckbox = (props) => {
  const { children, className, checked, ...rest } = props;
  const customClassName = `custom-checkbox ${className}`;
  const [check, setCheck] = useState(checked);

  return (
    <Checkbox
      {...rest}
      checked={check}
      onChange={() => setCheck(!check)}
      className={customClassName}>
      {children}
    </Checkbox>
  );
};

BaseCheckbox.defaultProps = {
  children: undefined,
  className: '',
  checked: false
};

BaseCheckbox.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node
  ]),
  className: PropTypes.string,
  checked: PropTypes.bool
};
